<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">
					<span v-if="item && category">Alterar ou renomear link</span>
					<span v-else>Adicione seu novo link</span>
				</p>
				<button class="delete" aria-label="close" @click="goBack"></button>
			</header>
			<form @submit.prevent="onSubmit()">

				<section class="modal-card-body">

					<div class="field" v-if="!category">
						<div class="control">
							<select class="input" v-model="chosenCategory" required>
								<option value="">Selecione a categoria</option>
								<option v-for="category in categories" :value="category.id">{{ category.name }}</option>
							</select>
						</div>
					</div>

					<div class="field">
						<div class="control">
							<input class="input" type="text" v-model="name" required placeholder="Descrição">
						</div>
					</div>
					<div class="field">
						<div class="control">
							<input class="input" type="url" v-model="url" required placeholder="URL" @keyup="validate" title="Insira um URL (endereço digital visível na barra de navegação de seu browser. Ex: www.gmail.com)">
						</div>
					</div>

					<div class="field">
						<div class="control">
							<label class="inputfile">
								<span v-if="fileHandler">{{ fileHandler.name }}</span>
								<span v-else>Escolher imagem</span>
								<input class="input" type="file" @change="onFileChange($event)">
							</label>

							<figure v-if="favicon" class="image image-preview">
								<img :src="favicon" alt="">
								<a @click="removeIcon" class="delete is-small"></a>
							</figure>

						</div>
					</div>

				</section>
				<footer class="modal-card-foot">
					<button type="submit" class="button is-success">Salvar</button>
					<button class="button" @click.prevent="goBack">Cancel</button>
				</footer>
			</form>
		</div>
	</div>
</template>


<style>
.inputfile{
cursor: pointer;
}
.inputfile span{}
.inputfile span i {}
.inputfile span:before{
	content:'';
width:30px; height:30px;
display: inline-block;
    border: 4px solid #fff;
    box-shadow: 0 0 5px rgba(0,0,0,.5);
    background: url(/images/ico-upload.png) no-repeat center #00b3bc;
    background-size: 14px;
    vertical-align: -8px;
    margin-right: 10px;
    border-radius: 5px;

}


.inputfile input{ display: none }
.image-preview {
	display: flex;
	align-items: flex-start;
	margin-top:10px;
	padding: 5px;
	background: #fff;
	border-radius: 5px;
	width: 61px;
	height: 61px;
}
.image-preview img {
	width:100%;
	height:100%;
	object-fit: contain;
}
.image-preview .delete {
	position: absolute;
	top:-5px;
	right: -5px;
	background: #aaa;
}
</style>

<script>
// @ is an alias to /src

export default {
	props:['category','item'],
	data() {
		return {
			name: '',
			url: 'http://',
			favicon: '',
			chosenCategory:'',
			fileHandler:null,
		}
	},
	computed: {
		userId() {
			return this.$store.getters.userId;
		},
		categories() {
			return this.$store.state.categories.categories;
		},
	},
	methods:{
		validate(){
			if(this.url.match(/^https?:\/\/https?:\/\//)){
				this.url = this.url.replace(/https?:\/\/(https?:\/\/)/,'$1');
			}
		},
		goBack(){
			this.$router.push({name:'home'});
		},

		onSubmit(){

			var data = {
				name:this.name,
				url:this.url,
				favicon:this.favicon,
				category_id:this.category || this.chosenCategory,
			}

			if(this.item && this.item.id){
				this.$store.dispatch('updateLink',{link_id:this.item.id,data:data});
			} else {
				data.index=99;
				this.$store.dispatch('addLink',{data:data});
			}

			//popup para registrar usuário anonimo
			if(askRegisterAnonymous(this.$store.state)) {
				this.$router.push({name:'formRegistrar'});
				return;
			}

			this.goBack();

		},
		onFileChange(e){
			console.log('change');
			var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var file = files[0];
      this.fileHandler = file;
      console.log(file);
    	var reader = new FileReader();
			var img = new Image();
      reader.onload = (re) => {

				console.log('reader load');
				img.onload = (ie) => {
					console.log('img load');

					var MAX_WIDTH = 128;
					var MAX_HEIGHT = 128;
					var width = img.width;
					var height = img.height;

					if (width > height) {
						if (width > MAX_WIDTH) {
							height *= MAX_WIDTH / width;
							width = MAX_WIDTH;
						}
					} else {
						if (height > MAX_HEIGHT) {
							width *= MAX_HEIGHT / height;
							height = MAX_HEIGHT;
						}
					}

					var canvas = document.createElement('canvas');
					var ctx = canvas.getContext("2d");

					canvas.width = width;
					canvas.height = height;
					ctx.drawImage(img, 0, 0, width, height);
					var dataurl = canvas.toDataURL("image/jpeg");

					this.favicon = dataurl;
					console.log(dataurl);

				}
				img.src = re.target.result;
      }
      reader.readAsDataURL(file);
		},
		removeIcon(){
			this.favicon = '';
			this.fileHandler = null;
		}
	},
	mounted() {
		if(this.item){
			this.name = this.item.name;
			this.url = this.item.url;
			this.favicon = this.item.favicon || '';
		}
	},
};
</script>

